import PropTypes from 'prop-types';
import React from 'react';

import logoSynlab from '../../images/logos/logo-synlab.svg';
import logoUnilabs from '../../images/logos/logo-unilabs.svg';
import Link from '../framework/link';
import './labs.scss';

const LabLogos = () => {
	return (
		<div className="d-flex pt-4 align-items-center gap-3">
			<Link className="" to="/partners/">
				<img
					alt="Synlab"
					className="img-fluid labs-logo footer-logos p-1"
					loading="lazy"
					src={logoSynlab}
				/>
			</Link>
			<Link className=" " to="/partners/">
				<img
					alt="Unilabs"
					className="img-fluid labs-logo footer-logos p-1"
					loading="lazy"
					src={logoUnilabs}
				/>
			</Link>
		</div>
	);
};

LabLogos.propTypes = {
	single: PropTypes.bool,
};

export default LabLogos;
